import { useTranslator } from '@gandi/translate';
import { ContentBlock } from './ContentBlock';
import { jsx as _jsx } from "react/jsx-runtime";
export function HostingBlock() {
  const {
    __
  } = useTranslator();
  return /*#__PURE__*/_jsx(ContentBlock, {
    productType: "paas",
    buttonUrl: "/simplehosting/create",
    buttonText: __('Get my web package'),
    children: /*#__PURE__*/_jsx("p", {
      children: __('Create one or more websites, plus two personalized emails and a domain name.')
    })
  });
}